export default __webpack_public_path__ + "static/media/Abyssal Demon Pendant of Intelligence.f191d881.jpg";